import { aiOpenapiClient, unwrapResult } from '@/api/openapi-client';
import { useRestaurantStore } from '@/stores/restaurant.store';
import type { MenuImportReview } from '@restaurant/api-client';
import { useQuery } from '@tanstack/react-query';

export function useMenuImportReview(menuId: string, enabled = true) {
  const restaurantId = useRestaurantStore((s) => s.selectedRestaurantId) ?? '';
  return useQuery({
    queryKey: ['menu', 'import-review', restaurantId, menuId],
    enabled: enabled && !!restaurantId,
    queryFn: async () =>
      unwrapResult<MenuImportReview>(
        await aiOpenapiClient.GET('/restaurants/{restaurantId}/ai/menus/{menuId}/import-review', {
          params: { path: { restaurantId, menuId } },
        }),
      ),
  });
}
